import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const loadBuildings = async () => {
  const response = await Api.get('instances/buildings?per_page=200');
  if (response.status === 200) {
    return response.data.data.map(building => ({
      label: `${building.name} [${building.city.code}-${building.city.country.code}]`,
      value: building.id,
    }));
  }
  return [];
};

const BuildingsSelector = ({
  dynastyId,
  cityId,
  onChanged,
  selectedIds,
}) => {
  const [buildings, setBuildings] = useState([]);

  useEffect(() => {
    loadBuildings(cityId, dynastyId).then(data => setBuildings(data));
  }, [cityId, dynastyId, loadBuildings]);

  useEffect(() => {
    loadBuildings(cityId, dynastyId).then(data => setBuildings(data));
  }, []);
  let selectedItems;
  if (selectedIds) {
    selectedItems = buildings.filter(b => selectedIds.includes(b.value));
    console.log({
      selectedIds,
      buildings,
      selectedItems,
    });
  }
  return (
    <Select
      options={buildings}
      value={selectedItems}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Building"
      isMulti
    />
  );
};

BuildingsSelector.propTypes = {
  dynastyId: PropTypes.number,
  cityId: PropTypes.number,
  onChanged: PropTypes.func,
  selectedIds: PropTypes.array,
};

BuildingsSelector.defaultProps = {
  dynastyId: undefined,
  cityId: undefined,
  onChanged: undefined,
  selectedIds: undefined,
};

export default BuildingsSelector;
